export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

export const FETCH_SCHEDULE = 'FETCH_SCHEDULE';
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';

export const FETCH_WORKEXP = 'FETCH_WORKEXP';
export const CREATE_WORKEXP = 'CREATE_WORKEXP';
export const UPDATE_WORKEXP = 'UPDATE_WORKEXP';
export const DELETE_WORKEXP = 'DELETE_WORKEXP';

export const FETCH_COUPONS = 'FETCH_COUPONS';
export const CREATE_COUPON = 'CREATE_COUPON';

export const FETCH_MHPS = 'FETCH_MHPS';
export const UPDATE_MHP = 'UPDATE_MHP';
